import { Check, View } from "lucide-react";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { CustomProperty } from "winslow-core";


type AppCustomPropertyDateProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyDate = ({customProperty, data, validate, onChange} : AppCustomPropertyDateProps) => {

    const [date, setDate] = useState<Date | null>(data ? new Date(data) : new Date());

    useEffect(() => {
        onChange(customProperty.label, date);
    }, [date]);

    return (
        <div className="app-custom-property-date">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <DatePicker
                    selected={date} 
                    dateFormat={"MM/dd/yyyy"}
                    
                    onChange={(date) => {
                        console.log("DatePicker date", date);
                        setDate(date as Date | null);
                        onChange(customProperty.label, date);
                    }}
                    className="date-picker-input"
                    wrapperClassName="app-date-picker-wrapper"
                />
                
                {validate && !date && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                }
            </div>
        </div>
    )
}
